export const verifyAdmin = (uid) => {
    var AdminArr = ["L6cSqhFxTWgyv5yGITRBHBRWqPJ2", "MuAj1R4dPvemkphkS22Ye0krlt72", "mwnEIzB9pnNPqMYKKyMRM2P8r9b2"]
    console.log(AdminArr.indexOf(uid))
    if (AdminArr.indexOf(uid) !== -1) {
        return true
    }
    else {
        return false
    }
}